import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PriceValidation } from 'uplisting-frontend/validations';

export default class PriceRepositoryService extends BaseRepositoryService<
  ModelRegistry['price']
> {
  recordName = 'price';
  implementMethods = ['buildChangeset', 'save'];

  validation = PriceValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/price': PriceRepositoryService;
  }
}
